import { CommitmentsTabProps } from "features/commitments/tabs/CommitmentsTabProps";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { useCurrentPageTabId } from "shared/navigation/useCurrentPageTabId";

export const CommitmentsPage: React.FC = () => {
  const { fundFamilyId } = useRequiredStringParams();
  const { t } = useTranslation(["commitment", "investorTransfer", "common"]);
  const tabId = useCurrentPageTabId();

  const tabContext: CommitmentsTabProps = {
    fundFamilyId,
  };

  return (
    <PageContent isFullHeight={tabId === "fundFamilyCommitmentsClosingsTab"}>
      <PageHeader title={t("common:commitments")} />
      <PageBody>
        <PageTabs context={tabContext} />
      </PageBody>
    </PageContent>
  );
};
